import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Modal from "react-modal";
import Layouts from "../../layouts/layouts";
import Select from "react-select";

Modal.setAppElement("#root");

export default function Create_lead() {
  const title = "Add Leads";
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  const [formData, setFormData] = useState({
    timestamp: "",
    agent_name: "",
    phone_number: "",
    customer_name: "",
    business_name: "",
    address: "",
    business_category: "",
    interested: "",
    remarks: "",
    email: "",
  });

  const [errors, setErrors] = useState({});

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const validateForm = () => {
    const newErrors = {};

    if (!formData.agent_name) {
      newErrors.agent_name = "Agent Name  is required.";
    }
    if (!formData.phone_number) {
      newErrors.phone_number = "Phone Number is required.";
    }
    if (!formData.customer_name) {
      newErrors.customer_name = "Customer Name is required.";
    }
    if (!formData.remarks) {
      newErrors.remarks = "Remarks is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/business-category`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data.categories);
        setCategories(response.data.categories);
        console.log("Categories fetched:", response.data.categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]);
      }
    };
    fetchCategories();
  }, []);
  const handleCategoryChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      business_category: selectedOption ? selectedOption.value : "",
    }));
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const data = new FormData();
    if (formData.agent_name) {
      data.append("agent_name", formData.agent_name);
    }
    if (formData.timestamp) {
      data.append("timestamp", formData.timestamp);
    }
    data.append("phone_number", formData.phone_number);
    data.append("customer_name", formData.customer_name);
    data.append("business_name", formData.business_name);
    data.append("address", formData.address);
    data.append("business_category", formData.business_category);
    data.append("interested", formData.interested);
    data.append("remarks", formData.remarks);
    data.append("email", formData.email);

    for (let [key, value] of data.entries()) {
      console.log(`${key}: ${value}`);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/leads`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Response data:", response.data.lead);

      if (response.status === 201) {
        navigate("/lead");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      //   console.error("Error:", error);

      console.error("Error:", error.response ? error.response.data : error);
    }
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="timestamp">
                  <b> Date * </b>
                </label>
                <input
                  type="date"
                  name="timestamp"
                  onChange={onChangeHandler}
                  className="form-control"
                  value={formData.timestamp || ""}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="agent_name">
                  <b>Agent Name * </b>
                </label>
                <input
                  type="text"
                  name="agent_name"
                  placeholder="Agent name"
                  className="form-control"
                  value={formData.agent_name}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="phone_number">
                  <b>Phone Number * </b>
                </label>
                <input
                  type="number"
                  name="phone_number"
                  placeholder="Phone Number"
                  className="form-control"
                  value={formData.phone_number}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="customer_name">
                  <b>Customer Name *</b>
                </label>
                <input
                  type="text"
                  name="customer_name"
                  placeholder="Customer Name"
                  className="form-control"
                  value={formData.customer_name}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="business_name">
                  <b>Business Name </b>
                </label>
                <input
                  type="text"
                  name="business_name"
                  placeholder="Business Name"
                  className="form-control"
                  value={formData.business_name}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="address">
                  <b>Address </b>
                </label>
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  className="form-control"
                  value={formData.address}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="email">
                  <b>Email </b>
                </label>
                <input
                  type="text"
                  name="email"
                  placeholder="Email"
                  className="form-control"
                  value={formData.email}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="interested">
                  <b>Interested* </b>
                </label>
                <select
                  name="interested"
                  className="form-control"
                  value={formData.interested}
                  onChange={onChangeHandler}
                >
                  <option value="">Select Option</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="id_category">
                  <b>Business Category * </b>
                </label>
                <Select
                  name="business_category"
                  options={categories.map((category) => ({
                    value: category._id,
                    label: `${category.name}`,
                  }))}
                  onChange={(selectedOption) =>
                    handleCategoryChange(selectedOption)
                  }
                  classNamePrefix="select"
                />
              </div>
              <div className="col-md-6 mt-3"></div>
              <div className="col-12 mt-3">
                <label htmlFor="remarks">
                  <b>Visit Remarks *</b>
                </label>
                <textarea
                  name="remarks"
                  type="text"
                  placeholder="Enter Description"
                  rows="5"
                  className="form-control"
                  value={formData.remarks}
                  onChange={onChangeHandler}
                ></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Lead
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
